import React, { FC } from 'react';
import AppBar from '@material-ui/core/AppBar';
import CloseIcon from '@material-ui/icons/Close';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { UploadDocument } from 'features/Documents/UploadDocument';
import { DocumentsList } from 'features/Documents/DocumentsList';
import { DocLinkType } from 'routes/routes';

interface DocumentsDialogProps {
  closeFn: () => void;
  docType:
    | DocLinkType.PRODUCT
    | DocLinkType.SERIAL_NUMBER
    | DocLinkType.DATA_SHEET_TEMPLATE
    | DocLinkType.DATA_SHEET
    | DocLinkType.ORDER_LIST;
  open: boolean;
  resourceId: string;
}

const DocumentsDialog: FC<DocumentsDialogProps> = ({ closeFn, docType, open, resourceId }) => (
  <Dialog aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description" open={open} fullScreen>
    <AppBar position="sticky">
      <Toolbar>
        <IconButton edge="start" color="inherit" onClick={closeFn} aria-label="close">
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
          {resourceId}
        </Typography>
      </Toolbar>
    </AppBar>
    <div style={{ padding: '40px' }}>
      <DocumentsList id={resourceId} type={docType} />
    </div>
  </Dialog>
);

export { DocumentsDialog };
